// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const amka: CountryValidator<"GR"> = createValidator(
  "gr.amka",
  86,
);

export default amka;
export const compact = amka.compact;
export const format = amka.format;
export const validate = amka.validate;
export const generate = (): string =>
  amka.generate?.() ??
  (() => {
    throw new Error(
      "Validator gr.amka cannot generate values",
    );
  })();
